<template>
    <div class="p-3">
        <div class="row">
            <div class="col-md-12">
                <h2>{{transEdit('remove-substitute')}}</h2>
                <hr>
                <h4>{{getDateTime(schedule.start)}}</h4>
                <h5>{{schedule.therapist.user.name}}</h5>
                <hr>
                <div class="form-group">
                    <label>Ordinarie personal: </label>
                    <span>{{schedule.original_therapist.user.name}}</span>
                    <!--<select class="form-control" required v-model="selectedTherapist">
                        <template v-for="therapist in therapists">
                            <template v-if="therapist.user">
                                <option :value="therapist.id">{{therapist.user.name}}</option>
                            </template>
                        </template>
                    </select>-->
                </div>
                <div >
                    <button class="btn btn-primary" @click="removeTherapist"><i class="fa fa-check"></i> {{transEdit('accept')}}</button>
                    <button class="btn btn-dark" @click="$emit('close')"><i class="fa fa-ban"></i> {{transEdit('cancel')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
    export default {
        name: "RemoveSubstituteModal",
        props: ['schedule'],
        methods: {
            removeTherapist(){
                axios.delete('/therapists/substitute', {
                    data: {'schedule_id': this.schedule.id}
                }).then((res) => {
                    if(!res.error) {
                        Vue.toasted.success(res.data.data);
                        this.$emit('close');
                    } else {
                        Vue.toasted.error(res.data[1]);
                    }
                });
            },
            getDateTime(dateString){
                return moment(dateString).format('YYYY-MM-DD HH:mm')
            },
            getTime(dateString){
                return moment(dateString).format('HH:mm')
            },
        },
        mounted(){
            if(this.schedule.treatments.length  == 1){
                this.selectedTreatment = this.schedule.treatments[0].id
            }
            axios.post('/therapists/getsubstitutes', {
                'schedule_id': this.schedule.id,
            }).then((res) => {
                if(res.data[0]) {
                    this.therapists = res.data;
                } else {
                    Vue.toasted.error(res.data[1]);
                }
            });
        }

    }
</script>

<style scoped>

</style>
